import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/logo-1.png';
import Footer from '../../components/Layout/Footer';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/page-header-bg.jpg';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import VideoOne from '../home-2/VideoOne';
import EventMain from './EventMain';
import BannerOne from './Banner';
import CtaFour from '../../components/Common/CtaSection/CtaFour';


// Breadcrumbs Background Image

const Event = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("scroll", handleScroll);
        return () => document.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <React.Fragment>
        <Header
            navImg={navImg1}
            parentMenu='event'
            activeMenu="/event"
        />
        {/* SiteBreadcrumb */}
        {/* <SiteBreadcrumb
            pageTitle="Event"
            pageName="Event"
            breadcrumbsImg={bannerbg}
        /> */}

        {/* Banner */}
        {/* <BannerOne /> */}
        {/* SiteBreadcrumb */}
        <EventMain/>
        {/*cta-section */}
        <CtaFour/>
        {/*cta-section end */}
        {/* VideoOne */}
        <VideoOne />
        <BackToTop scroll={isVisible} />
        <Footer />
    </React.Fragment>
    );
}

export default Event;